import { IntlShape } from 'react-intl'

import {
  createSelectOption,
  getFullContactName,
  parseStreetString,
} from 'Utilities'

import { ADDRESSES } from 'Constants/constants'
import { CountriesEN } from 'Constants/CountriesEN'
import { getPortalConfig_portalConfigStoreForUserAndOrg } from 'Constants/graphql/queries/detail/__generated__/getPortalConfig'
import { getRental_rental } from 'Constants/graphql/queries/detail/__generated__/getRental'
import { getOrganisation_organisation } from 'Constants/graphql/queries/organisation/__generated__/getOrganisation'

import { ShippingAddressTypeEnum } from 'Types/address/address.types'

import { ShippingAddressFormAddressTypeConfig } from './ShippingAddressForm.types'
import { shippingFormDefaultValues } from './ShippingAddressForm.values'

export const parseAddressTypeRadioButtons = (
  intl: IntlShape,
  portalConfig: getPortalConfig_portalConfigStoreForUserAndOrg | null,
  organisation: getOrganisation_organisation | null,
  rental: getRental_rental,
) => {
  const addressTypes: ShippingAddressFormAddressTypeConfig[] = []

  if (
    rental?.organisation?.contact?.address &&
    portalConfig?.shipToOfficeAddress
  ) {
    const { address } = rental.organisation.contact

    const parsedStreet = parseStreetString(address.street || '')
    const countryLabel = address.country ? CountriesEN[address.country] : ''

    addressTypes.push({
      _label: `${rental.organisation.shortName} Office`,
      address: address.street || '',
      addressType: ShippingAddressTypeEnum.OFFICE,
      city: address.city || '',
      country: createSelectOption({
        label: countryLabel,
        value: address.country,
      }),
      name: rental.organisation.fullName || '',
      nameAddition: address.nameAddition || '',
      street: parsedStreet.streetName || '',
      streetNumber: parsedStreet.streetNumber || '',
      zipcode: address.zipcode || '',
    })
  } else if (
    organisation?.contact?.address &&
    portalConfig?.shipToOfficeAddress
  ) {
    const { address } = organisation.contact

    const parsedStreet = parseStreetString(address.street || '')
    const countryLabel = address.country ? CountriesEN[address.country] : ''

    addressTypes.push({
      _label: `${organisation.shortName} Office`,
      address: address.street || '',
      addressType: ShippingAddressTypeEnum.OFFICE,
      city: address.city || '',
      country: createSelectOption({
        label: countryLabel,
        value: address.country,
      }),
      name: organisation.fullName || '',
      nameAddition: address.nameAddition || '',
      street: parsedStreet.streetName || '',
      streetNumber: parsedStreet.streetNumber || '',
      zipcode: address.zipcode || '',
    })
  }

  if (portalConfig?.shipDeviceToCustomAddress) {
    if (rental?.employee?.contact?.address) {
      const { address } = rental.employee.contact
      let name = ''

      if (address.name) {
        name = address.name
      } else {
        name = getFullContactName(rental.employee.contact)
      }

      const parsedStreet = parseStreetString(address.street || '')
      const countryLabel = address.country ? CountriesEN[address.country] : ''

      const customAddress = {
        _label: intl.formatMessage({
          id: ADDRESSES.CUSTOM_ADDRESS_LABEL,
        }),
        address: address.street || '',
        addressType: ShippingAddressTypeEnum.HOME_ADDRESS,
        city: address.city || '',
        country: createSelectOption({
          label: countryLabel,
          value: address.country,
        }),
        name,
        nameAddition: address.nameAddition || '',
        street: parsedStreet.streetName || '',
        streetNumber: parsedStreet.streetNumber || '',
        zipcode: address.zipcode || '',
      }

      if (portalConfig?.customDeliveryAddress) {
        addressTypes.unshift(customAddress)
      } else {
        addressTypes.push(customAddress)
      }
    } else {
      const customAddress = {
        ...shippingFormDefaultValues,
        _label: intl.formatMessage({
          id: ADDRESSES.CUSTOM_ADDRESS_LABEL,
        }),
      }

      if (portalConfig?.customDeliveryAddress) {
        addressTypes.unshift(customAddress)
      } else {
        addressTypes.push(customAddress)
      }
    }
  }

  return addressTypes
}
